<template>
  <div class="case-analysis">
    <div class="c-list">
      <div
        class="c-list-item"
        v-for="(item, index) in patientAnalysisList"
        :key="index"
      >
        <div class="title fjcsb">
          <span v-if="item.type == 1"
            >{{ item.startTime?.split(" ")[0] }} 提交到病案分析
            <span v-if="item.analysisResource == 3" class="red">(医闹)</span>
          </span>
          <span v-else>{{ item.updDtString?.split(" ")[0] }} 云诊病案分析</span>
          <div
            class="button-group"
            v-if="
              item.type == 2 || (item.type == 1 && [5, 6].includes(item.label))
            "
          >
            <Button size="small" @click="openWuxing(item)" v-if="item.type != 1">五行图</Button>
            <Button size="small" @click="open1(item)">详情</Button>
          </div>
        </div>
        <div class="other">
          <div v-if="item.updDtString">分析时间：{{ item.updDtString }}</div>
          <div v-if="item.bhCrTime">提交时间：{{ item.bhCrTime }}</div>
          <div v-if="item.analysisCause">
            原因：<span v-html="item.analysisCause"></span>
          </div>
          <div v-if="item.auditName">审核人：{{ item.auditName }}</div>
          <div v-if="item.auditStartTime">
            审核开始时间：{{ item.auditStartTime }}
          </div>
          <div v-if="item.auditTime">审核时间：{{ item.auditTime }}</div>
          <div v-if="item.feedbackResult">
            反馈结果：{{ item.feedbackResult }}
          </div>
          <div v-if="item.feedbackTime">
            反馈完成时间：{{ item.feedbackTime }}
          </div>
        </div>
        <div class="footer">
          <span class="red">{{
            common.valueToLabel(labelType, item.label)
          }}</span>
        </div>
      </div>
      <empty v-if="patientAnalysisList.length === 0">暂无数据</empty>
    </div>
    <!-- <caseAnalysisDialog ref="caseAnalysisDialogRef" /> -->
    <caseAnalysisDetail
      :patientCode="activeItem.patientCode"
      :taskInfo="activeItem"
      :showDialog="showDialog"
      @toggleHandle="closeDialog"
    />
    <yzDetail
      v-model="showYzDetail"
      :taskInfo="taskInfo"
      :patientCode="patientCode"
    />
    <WCModal ref="wuxingCompareRef" />
  </div>
</template>


<script>
import request from "@/utils/request";
import caseAnalysisDialog from "./com/caseAnalysisDialog.vue";
import yzDetail from "./com/yzDetail.vue";
import caseAnalysisDetail from "./com/caseAnalysisDetail.vue";

export default {
  props: {
    patientCode: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    caseAnalysisDetail,
    caseAnalysisDialog,
    yzDetail,
  },
  data() {
    return {
      showDialog: false,
      activeItem: {},

      taskInfo: {},
      showYzDetail: false,
      patientAnalysisList: [],
      //"0 服药满月 1 百会回访 2 人工添加 3 医闹"
      analysisResourceList: [
        {
          label: "服药满月",
          value: "0",
        },
        {
          label: "百会回访",
          value: "1",
        },
        {
          label: "人工添加",
          value: "2",
        },
        {
          label: "医闹",
          value: "3",
        },
      ],
      //1 待分析 2 分析中 3 分析文档待审核 4 无法分析 5 待反馈给患者 6 已反馈给患者 7 医生审核不通过
      labelType: [
        { label: "待分析", value: "1" },
        { label: "分析中", value: "2" },
        { label: "分析文档待审核", value: "3" },
        { label: "无法分析", value: "4" },
        { label: "待反馈给患者", value: "5" },
        { label: "已反馈给患者", value: "6" },
        { label: "医生审核不通过", value: "7" },
      ],
    };
  },
  methods: {
    openWuxing  (item )  {
      this.taskInfo = item;
      this.$refs.wuxingCompareRef.open({...item, patientCode: this.patientCode });
    },
    closeDialog() {
      this.showDialog = false;
    },
    open1(item) {
      this.taskInfo = item;
      if (item.type == 1) {
        this.activeItem = item;
        this.showDialog = true;
        // this.$refs.caseAnalysisDialogRef.open(item);
      } else {
        this.showYzDetail = true;
      }
    },
    getData() {
      request
        .post("/saasbaihui/patientAnalysisListNew", {
          patientCode: this.patientCode,
        })
        .then((res) => {
          this.patientAnalysisList = res.result;
        });
    },
  },
  mounted() {
    this.getData();
    this.$bus.on("addCaseAnalysisSuccess", this.getData);
  },
  beforeDestroy() {
    this.$bus.off("addCaseAnalysisSuccess", this.getData);
  },
};
</script>


<style scoped lang="scss">
.case-analysis {
  padding: 15px;
  .c-list-item {
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
    .button-group {
      text-align: right;
      .ivu-btn + .ivu-btn {
        margin-left: 10px;
      }
    }
    .title {
      font-weight: bold;
    }
    .other {
      opacity: 0.6;
      padding: 8px 0;
    }
  }
}
</style>